import React from "react";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { ecosystem } from "../mock";

const EcosystemSection = () => {
  return (
    <section id="ecosystem" className="section-navy relative scroll-mt-20 overflow-hidden py-16 md:py-24">
      <div className="pointer-events-none absolute -right-24 top-1/3 h-96 w-96 rounded-full bg-white/[0.04] blur-3xl" />
      <div className="relative mx-auto max-w-6xl px-4 md:px-8">
        <Reveal className="mx-auto mb-16 max-w-3xl text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#E7625B]">
            The Ecosystem
          </span>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-white md:text-4xl">
            One connected business ecosystem
          </h2>
          <p className="mt-5 text-lg font-light leading-relaxed text-white/70">
            {ecosystem.intro}
          </p>
        </Reveal>

        {/* Anchor brand */}
        <Reveal className="mb-10 text-center">
          <div className="inline-flex flex-col items-center">
            <img src="/brand/continex-logo.png" alt="Continex" className="h-11 w-auto" />
            <span className="mt-3 text-sm text-white/60">
              {ecosystem.anchor.line}
            </span>
          </div>
        </Reveal>

        {/* Connector */}
        <div className="mx-auto mb-10 h-10 w-px bg-white/20" />

        {/* Branches */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {ecosystem.branches.map((b, i) => (
            <Reveal key={b.id} delay={i * 120}>
              <div className="group flex h-full flex-col rounded-2xl border border-white/20 bg-white/[0.08] p-8 transition-all duration-300 hover:-translate-y-1 hover:border-white/30 hover:bg-white/[0.13]">
                {/* Logo chip */}
                <div className="mb-6 flex flex-wrap items-center gap-4">
                  {b.logo ? (
                    <img
                      src={b.logo}
                      alt={b.name}
                      className="h-10 w-auto max-w-[190px] object-contain"
                    />
                  ) : (
                    <span className="flex flex-col">
                      <span
                        className="text-xl font-bold tracking-tight"
                        style={{ color: b.color }}
                      >
                        {b.name}
                      </span>
                      <span className="mt-0.5 text-[10px] font-medium uppercase tracking-[0.18em] text-white/40">
                        Identity in progress
                      </span>
                    </span>
                  )}
                  <span className="text-xs uppercase tracking-[0.18em] text-white/50">
                    {b.tagline}
                  </span>
                </div>
                <p className="flex-1 text-[15px] leading-relaxed text-white/70">
                  {b.desc}
                </p>
                <a
                  href={b.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-white transition-all duration-200 hover:gap-3"
                >
                  Discover {b.name}
                  <ArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EcosystemSection;
